import {
  OfferTextAlternateLeaseTitle,
  OfferTextAprPricingTitle,
  OfferTextBuyTitle,
  OfferTextInventoryButtonText,
  OfferTextLeaseTitleText,
  OfferTextMarketValueText,
  OfferTextMsrpTitle,
  OfferTextSelectOption
} from './offer-text.models';

export const offerTextMsrpTitleOptions = [
  {label: 'MSRP', value: 'MSRP'},
  {label: 'Total MSRP', value: 'Total MSRP'},
  {label: 'TSRP', value: 'TSRP'}
] as const satisfies ReadonlyArray<OfferTextSelectOption<OfferTextMsrpTitle>>;

export const offerTextMarketValueTextOptions = [
  {label: 'Market Value', value: 'Market Value'},
  {label: 'Starting Price', value: 'Starting Price'},
  {label: 'Original Value', value: 'Original Value'},
  {label: 'MSRP', value: 'MSRP'}
] as const satisfies ReadonlyArray<OfferTextSelectOption<OfferTextMarketValueText>>;

export const offerTextBuyTitleOptions = [
  {label: 'Buy for', value: 'Buy for'},
  {label: 'Sale Price', value: 'Sale Price'},
  {label: 'Offering Price', value: 'Offering Price'},
  {label: 'Starting At', value: 'Starting At'},
  {label: 'Net Cost', value: 'Net Cost'},
  {label: 'MSRP', value: 'MSRP'},
  {label: 'Selling Price', value: 'Selling Price'},
  {label: 'Total MSRP', value: 'Total MSRP'},
  {label: 'TSRP', value: 'TSRP'},
  {label: 'Dealer Price', value: 'Dealer Price'},
  {label: 'Net Price', value: 'Net Price'}
] as const satisfies ReadonlyArray<OfferTextSelectOption<OfferTextBuyTitle>>;

export const offerTextAprPricingTitleOptions = [
  {label: '', value: ''},
  {label: 'x% APR', value: 'APR'},
  {label: 'Available APR', value: 'Available APR'},
  {label: 'Finance APR', value: 'Finance APR'},
  {label: 'APR Finance', value: 'APR Finance'}
] as const satisfies ReadonlyArray<OfferTextSelectOption<OfferTextAprPricingTitle>>;

export const offerTextLeaseTitleTextOptions = [
  {label: 'Lease for', value: 'Lease for'},
  {label: 'Lease from', value: 'Lease from'}
] as const satisfies ReadonlyArray<OfferTextSelectOption<OfferTextLeaseTitleText>>;

const newAlternateLeaseTitleBaseOptions = [
  {label: '', value: ''},
  {label: 'Zero Down Lease', value: 'Zero Down Lease'},
  {label: 'Zero Down Lease From', value: 'Zero Down Lease From'},
  {label: 'Sign and Drive', value: 'Sign and Drive'},
  {label: 'Sign and Drive Lease', value: 'Sign and Drive Lease'},
  {label: 'Sign Then Drive', value: 'Sign Then Drive'},
  {label: 'Sign Then Drive Lease', value: 'Sign Then Drive Lease'},
  {label: 'Zero Down Payment Lease', value: 'Zero Down Payment Lease'},
  {label: 'One Penny Down Lease', value: 'One Penny Down Lease'},
  {label: 'One Penny Down Lease from', value: 'One Penny Down Lease from'},
  {label: 'Lease for', value: 'Lease for'}
] as const satisfies ReadonlyArray<OfferTextSelectOption<OfferTextAlternateLeaseTitle>>;

const usedAlternateLeaseTitleBaseOptions = [
  {label: '', value: ''},
  {label: 'Alternate Lease', value: 'Zero Down Lease'},
  {label: 'Alternate Lease From', value: 'Zero Down Lease From'},
  {label: 'Sign and Drive', value: 'Sign and Drive'},
  {label: 'Sign and Drive Lease', value: 'Sign and Drive Lease'},
  {label: 'Sign Then Drive', value: 'Sign Then Drive'},
  {label: 'Sign Then Drive Lease', value: 'Sign Then Drive Lease'},
  {label: 'Alternate Lease Zero Down Payment Lease', value: 'Zero Down Payment Lease'},
  {label: 'One Penny Down Lease', value: 'One Penny Down Lease'},
  {label: 'One Penny Down Lease from', value: 'One Penny Down Lease from'},
  {label: 'Lease for', value: 'Lease for'}
] as const satisfies ReadonlyArray<OfferTextSelectOption<OfferTextAlternateLeaseTitle>>;

const alternateLeaseConditionalOptions = [
  {label: 'Conquest Lease for', value: 'Conquest Lease for'},
  {label: 'Loyalty Lease for', value: 'Loyalty Lease for'}
] as const satisfies ReadonlyArray<OfferTextSelectOption<OfferTextAlternateLeaseTitle>>;

export const offerTextInventoryButtonTextOptions = [
  {label: 'View Vehicle', value: 'View Vehicle'},
  {label: 'View Inventory', value: 'View Inventory'}
] as const satisfies ReadonlyArray<OfferTextSelectOption<OfferTextInventoryButtonText>>;

export function buildNewAlternateLeaseTitleOptions(vehicleAdsEnabled: boolean): Array<OfferTextSelectOption<OfferTextAlternateLeaseTitle>>
{
  let options: Array<OfferTextSelectOption<OfferTextAlternateLeaseTitle>> = [...newAlternateLeaseTitleBaseOptions];

  if (!vehicleAdsEnabled) {
    options = [...options, ...alternateLeaseConditionalOptions];
  }

  return options;
}

export function buildUsedAlternateLeaseTitleOptions(vehicleAdsEnabled: boolean): Array<OfferTextSelectOption<OfferTextAlternateLeaseTitle>>
{
  let options: Array<OfferTextSelectOption<OfferTextAlternateLeaseTitle>> = [...usedAlternateLeaseTitleBaseOptions];

  if (!vehicleAdsEnabled) {
    options = [...options, ...alternateLeaseConditionalOptions];
  }

  return options;
}
